import type { PropsWithChildren } from 'react';
import { useTheme } from 'styled-components';

const LoginLayout = ({ children }: PropsWithChildren) => {
  const theme = useTheme();
  return <theme.layout.LoginLayout>{children}</theme.layout.LoginLayout>;
};

export default LoginLayout;
